const hotels=[
    {
        id:1,
        imgURL:"img/p13hotel.jpg",
        name:"The Soaltee Hotel",
        standard:"5 star Hotel",
        beforePrice:"Rs.50000",
        afterPrice:"Rs.45999"
    }
    ,
    {
        id:2,
        imgURL:"img/p14hotel.jpg",
        name:"Rupakot Resort",
        standard:"3 star Hotel",
        beforePrice:"Rs.42000",
        afterPrice:"Rs.36999"
    }
    ,
    {
        id:3,
        imgURL:"img/p15hotel.jpg",
        name:"Annapurna Resort",
        standard:" 3 star Hotel",
        beforePrice:"Rs.30000",
        afterPrice:"Rs.25999"
    }
    ,
    {
        id:4,
        imgURL:"img/p16hotel.jpg",
        name:"Harvest Moon Guest House",
        standard:"2 star Hotel",
        beforePrice:"Rs.10000",
        afterPrice:"Rs.8999"
    }
    
]


export default hotels;